import { Formik, Form } from 'formik';
import ScrollToError from 'components/common/ScrollToError';
import Button from 'components/common/Button';
import { useIntl } from 'react-intl';
import { ArrowBack, ArrowForward } from 'assets/icons';
import { Col, Row } from 'react-flexbox-grid';
import IndoorImg from 'assets/images/quick-calculator/buying-apartment.svg?react';
import SaveIcon from 'assets/icons/save.svg?react';
import ScrollToTop from 'components/common/ScrollToTop';
import { NEW_APARTMENT } from 'constants/constants';
import Features from '../../Features';
import s from '../../calculators.module.scss';
import validationSchema from '../yupSchemas/apartmentFourthStepSchema';
import type { IApartmentStepProps } from '../types';

const ApartmentFourthStep = ({
  isEditMode,
  lastStep,
  currentStep,
  onBack,
  onSubmit,
  previousStep,
  nextStep,
  formValuesRef,
  onSubmitStep,
}: IApartmentStepProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <Row between="lg" top="xs" center="md">
      <ScrollToTop />
      <Col md={12} lg={6}>
        <Formik
          initialValues={formValuesRef?.current}
          onSubmit={async (values, formikActions) => {
            onSubmitStep(values);
            await onSubmit({ values, formikActions, currentStep, isEditMode, lastStep, nextStep });
          }}
          validationSchema={validationSchema}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <ScrollToError />
              <Features values={values} group="indoor" projectType={NEW_APARTMENT} />

              <div className={s.buttonsWrapper}>
                {!isEditMode ? (
                  <Button
                    disabled={isSubmitting}
                    onClick={() => onBack(values, previousStep)}
                    startIcon={<ArrowBack />}
                  >
                    {t({ id: 'app.back' })}
                  </Button>
                ) : null}
                <Button
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  type="submit"
                  endIcon={isEditMode ? <SaveIcon /> : <ArrowForward />}
                  className="ml-auto"
                >
                  {t({ id: `app.${isEditMode ? 'save' : 'submit_form_next'}` })}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Col>
      <Col md={12} lg={6} first="xs" last="lg">
        <div className={s.imgBox}>
          <IndoorImg title={t({ id: 'alt_text.project_details_page.new_apartment.fourth_step' })} />
        </div>
      </Col>
    </Row>
  );
};

export default ApartmentFourthStep;
